import { defineMessages } from 'react-intl'

export const PROFILE_DIET_TYPE = {
  REGULAR: 'REGULAR',
  VEGETARIAN: 'VEGETARIAN',
  VEGAN: 'VEGAN',
  PESCATARIAN: 'PESCATARIAN',
  OTHER: 'OTHER'
}

export const PROFILE_DIET_TYPES = Object.values(PROFILE_DIET_TYPE)

const labels = defineMessages({
  regular: {
    id: 'ProfileDietType.regular',
    defaultMessage: 'Regular',
    description: 'User follows a regular, non-restrictive diet.'
  },
  vegetarian: {
    id: 'ProfileDietType.vegetarian',
    defaultMessage: 'Vegetarian',
    description: 'User is following a vegetarian diet.'
  },
  vegan: {
    id: 'ProfileDietType.vegan',
    defaultMessage: 'Vegan',
    description: 'User is following a vegan diet.'
  },
  pescatarian: {
    id: 'ProfileDietType.pescatarian',
    defaultMessage: 'Pescatarian',
    description: 'User is following a pescatarian diet (includes fish).'
  },
  other: {
    id: 'ProfileDietType.other',
    defaultMessage: 'Other',
    description: 'User follows another type of diet not listed.'
  }
})

export const PROFILE_DIET_TYPE_MESSAGE = {
  [PROFILE_DIET_TYPE.REGULAR]: labels.regular,
  [PROFILE_DIET_TYPE.VEGETARIAN]: labels.vegetarian,
  [PROFILE_DIET_TYPE.VEGAN]: labels.vegan,
  [PROFILE_DIET_TYPE.PESCATARIAN]: labels.pescatarian,
  [PROFILE_DIET_TYPE.OTHER]: labels.other
}

export const PROFILE_DIET_TYPE_EMOJI = {
  [PROFILE_DIET_TYPE.REGULAR]: '🍗',
  [PROFILE_DIET_TYPE.VEGETARIAN]: '🥚',
  [PROFILE_DIET_TYPE.VEGAN]: '🥦',
  [PROFILE_DIET_TYPE.PESCATARIAN]: '🐟',
  [PROFILE_DIET_TYPE.OTHER]: '🌟'
}
